var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"help_person_map"},[_c('div',{staticClass:"map_top"},[_c('i',{staticClass:"el-icon-location-information icon"}),_c('div',{staticClass:"map_title"},[_vm._v(" "+_vm._s(_vm.center)+" ")])]),_c('div',{attrs:{"id":"map"}})])}
var staticRenderFns = []

export { render, staticRenderFns }